import { AliasService } from './../../alias/alias.service';
import { AwsUtil } from './../../authentication/aws.service';
import { CurrencyDisplayUtil } from './../../common/currency-display-util';
import { PIE_COLOR_STRIP_1, PIE_COLOR_STRIP_2, PIE_COLOR_STRIP_3, PIE_COLOR_STRIP_4 } from './../../common/color-util';
import { AmChartsService } from '@amcharts/amcharts3-angular';
import { Component, OnInit, Inject, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import {
    GetTransactionDetailsResult,
    WebApiEndpoints,
    GetFullTransactionResult,
    GetFullTransactionRequest,

} from '@liquitics/transaction';
import { numberToString } from '@liquitics/transaction';
import { Transaction } from '@liquitics/transaction';

import { createSimplePieChart } from '../../common/chart/graphical-chart-generator';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-transaction-table',
    templateUrl: './transaction-table.component.html',
    styleUrls: ['./transaction-table.component.scss']
})
export class TransactionTableComponent implements OnInit, OnChanges {
    selectedTransactions: Transaction[];
    allColumns: any[];
    tableData: any[];
    @Input()
    rowsPerPage = 20;
    @Input()
    transactionDetailResult: GetTransactionDetailsResult;
    loading = true;
    fullTransaction: string;
    selectedTotal: string;

    constructor(private amChartsService: AmChartsService,
        private aliasService: AliasService,
        private awsUtil: AwsUtil
    ) {
    }

    ngOnInit() {
        this.allColumns = [
            // tslint:disable:max-line-length

            // { field: 'flowKey', header: 'Flow Key', width: '12em', type: 'string' },
            // { field: 'eventDatetime', header: 'Event Datetime', width: '6em', type: 'datetime', sortable: true },
            { field: 'typeClass', header: ' ', width: '1em', type: 'icon', sortable: false },
            { field: 'tradeDatetime', header: 'Trade Datetime', width: '6em', type: 'datetime', sortable: true },
            { field: 'settleDate', header: 'Settle Date', width: '4em', type: 'date', sortable: true },
            { field: 'direction', header: 'Dir', width: '2em', type: 'string', sortable: true },
            { field: 'currency', header: 'Ccy', width: '2em', type: 'string', sortable: true },
            { field: 'amount', header: 'Amount', width: '6em', type: 'amount', sortable: true },
            { field: 'organizationLevel', header: 'Org Level', width: '6em', type: 'string', sortable: true },
            { field: 'desk', header: 'Desk', width: '6em', type: 'string', sortable: true },
            // { field: 'account', header: 'Account', width: '6em', type: 'string', sortable: true },
            { field: 'accountShortName', header: 'Account', width: '6em', type: 'string', sortable: true },
            { field: 'client', header: 'Client', width: '6em', type: 'string', sortable: true },
            { field: 'clientGroup', header: 'Client Group', width: '6em', type: 'string', sortable: true },
            // { field: 'supplementaryRef', header: 'Suppl Ref', width: '6em', type: 'string' },
            { field: 'product', header: 'Product', width: '6em', type: 'string', sortable: true },
            { field: 'productType', header: 'Product Type', width: '4em', type: 'string', sortable: true },
            // { field: 'clearing', header: 'Clearing', width: '1em', type: 'boolean' },
            { field: 'source', header: 'Source', width: '4em', type: 'string', sortable: true },
            { field: 'externalId', header: 'External Id', width: '15em', type: 'string', sortable: true },
            // { field: 'secondaryId', header: 'Secondary Id', width: '6em', type: 'string' },
            // { field: 'flowScope', header: 'Flow Scope', width: '6em', type: 'string' },
            // { field: 'payClientAccount', header: 'payClientAccount', width: '6em', type: 'string' },
            // { field: 'recClientAccount', header: 'recClientAccount', width: '6em', type: 'string' },
            { field: 'showTransaction', header: ' ', width: '1em', type: 'show', sortable: false },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.transactionDetailResult && changes.transactionDetailResult.currentValue) {
            const allTableData = [];
            const allExpectedData = [];
            const allActualData = [];
            if (changes.transactionDetailResult.currentValue.todayTransactions) {
                allExpectedData.push(...changes.transactionDetailResult.currentValue.todayTransactions);
            }
            if (changes.transactionDetailResult.currentValue.recentTransactions) {
                allExpectedData.push(...changes.transactionDetailResult.currentValue.recentTransactions);
            }
            if (changes.transactionDetailResult.currentValue.settlements) {
                allActualData.push(...changes.transactionDetailResult.currentValue.settlements);
            }

            allExpectedData
                .forEach((transaction: Transaction) => {
                    this.formatExpectedForDisplay(transaction);
                    return transaction;
                });
            allActualData
                .forEach((transaction: Transaction) => {
                    this.formatActualForDisplay(transaction);
                    return transaction;
                });

            allTableData.push(...allExpectedData);
            allTableData.push(...allActualData);
            this.tableData = allTableData
        }
        this.loading = false;
    }

    showTransaction(event: any, transaction: Transaction, overlayPanel: OverlayPanel) {
        const request = {
            currency: transaction.currency,
            eventDatetime: transaction.eventDatetime,
            flowKey: transaction.flowKey
        } as GetFullTransactionRequest;
        this.awsUtil.webAPICall(WebApiEndpoints.QueryFullTransaction, request)
            .then((result: GetFullTransactionResult) => {
                this.fullTransaction = JSON.stringify(result, null, 2);
                overlayPanel.toggle(event);
            })
    }
    formatExpectedForDisplay(transaction: Transaction) {
        if (transaction.direction === 'PAY') {
            transaction['iconClass'] = 'fa fa-arrow-circle-right';
            transaction['dataClass'] = 'data-expected-pay';
            transaction['transactionType'] = 'Expected Pay';
        } else {
            transaction['iconClass'] = 'fa fa-arrow-circle-left';
            transaction['dataClass'] = 'data-expected-rec';
            transaction['transactionType'] = 'Expected Receive';
        }
        this.formatTransactionForDisplay(transaction);
    }
    formatActualForDisplay(transaction: Transaction) {
        if (transaction.direction === 'PAY') {
            transaction['iconClass'] = 'fa fa-arrow-circle-up';
            transaction['dataClass'] = 'data-actual-pay';
            transaction['transactionType'] = 'Actual Pay';
        } else {
            transaction['iconClass'] = 'fa fa-arrow-circle-down';
            transaction['dataClass'] = 'data-actual-rec';
            transaction['transactionType'] = 'Actual Receive';
        }
        this.formatTransactionForDisplay(transaction);
    }
    formatTransactionForDisplay(transaction: Transaction) {
        transaction['accountShortName'] = this.aliasService.accountShortName(transaction.account);
    }

    onTableRowSelect(event) {
        let selectedSum = 0;
        if (this.selectedTransactions) {
            selectedSum = this.selectedTransactions.reduce((sum, transaction: Transaction) => {
                sum += transaction.amount;
                return sum;
            }, 0);
        }
        this.selectedTotal = numberToString(selectedSum, '0.00a');
    }
}
